import { render, staticRenderFns } from "./employee-update.vue?vue&type=template&id=6bcc078a&scoped=true"
import script from "./employee-update.vue?vue&type=script&lang=js"
export * from "./employee-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcc078a",
  null
  
)

export default component.exports